module.exports = __webpack_public_path__ + "static/media/4_14_3.471b2c0e.jpg";